import { useBulkUpdateTaskDetailsMutation } from 'api/taskApi';
import { EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TaskAttributes } from 'types/api/tasks';
import { Button } from 'ui/components';
import { cn } from 'utils/cn';
import { getSelectedSiteInfo } from '../../../../store/siteInfoSlice';
import { getUser, setShowLockFeature } from '../../../../store/userSlice';

interface UnsetInternalButtonProps {
    taskId: string;
    task?: Partial<TaskAttributes>;
}

export default function UnsetInternalButton({
    taskId,
    task,
}: UnsetInternalButtonProps): JSX.Element {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const siteInfo = useSelector(getSelectedSiteInfo);
    // const showLockFeature = useSelector(getShowLockFeature);
    const [bulkUpdateTaskDetails, { isLoading }] =
        useBulkUpdateTaskDetailsMutation();

    const disabled = !user?.raw?.plan?.internal_tasks;

    const handleClick = async (): Promise<void> => {
        if (isLoading || !taskId || !task || !siteInfo) return;
        if (disabled) {
            dispatch(setShowLockFeature({
                showLockFeature: true,
                lockTitle: 'Internal Task',
                lockParagraph: 'Collaborate privately with your team on tasks hidden from stakeholders. Keep internal discussions organized and focused. Available on Starter, Expert, and Agency plans.',
                lockImg: "https://wpfeedback-image.s3.us-east-2.amazonaws.com/images/integration-lock-images/lock-user-image-3.jpg",
                rank: 3,
            }));
            return
        }
        try {
            await bulkUpdateTaskDetails({
                websiteId: siteInfo.id,
                taskId,
                internal: 0,
            }).unwrap();
            // toast.success(t('task.internal.unset.success', 'Task unset as internal'));
        } catch (error) {
            console.error('Failed to unset task as internal:', error);
            // toast.error(t('task.internal.unset.error', 'Failed to unset task as internal'));
        }
    };


    return (
        <Button
            data-testid="PostInternal InboxInternal"
            size="icon"
            variant="outline"
            onClick={handleClick}
            loading={isLoading}
            disabled={disabled}
            tooltipSide="top"
            tooltip={t('task.internal.unset.tooltip', 'Unset this task as internal')}
            className={cn(
                'bg-secondary hover:bg-secondary/90 text-white hover:text-white',
                isLoading && 'bg-secondary/50'
            )}
        >
            <EyeOff size={18} />
        </Button>
    );
}